var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.series.length > 0)?_c('vue-apex-charts',{attrs:{"type":_vm.type,"height":_vm.state.options.chart.height,"options":_vm.state.options,"color":_vm.color,"xaxisType":_vm.xaxisType,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }